import { DevicePermission } from '@office-start/metaos-hub-sdk';
export const getHubSdkDevicePermission = ({ permissionToTranslate, }) => {
    switch (permissionToTranslate) {
        case 'geolocation':
            return DevicePermission.GeoLocation;
        case 'media':
            return DevicePermission.Media;
        case 'midi':
            return DevicePermission.Midi;
        case 'notifications':
            return DevicePermission.Notifications;
        case 'openexternal':
            return DevicePermission.OpenExternal;
        default:
            // TODO: failed to convert app definition permissions: permission not supported
            return undefined;
    }
};
//# sourceMappingURL=getHubSdkDevicePermission.js.map